import {
    Row,
    Col,
    Card,
    Table,
    Button,
    Modal,
    Form,
    Input,
    Tag,
    DatePicker,
    Select,
    InputNumber,
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useContext, useEffect, useRef } from "react";
import { ToTopOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import { UploadOutlined, ExportOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
const { Option } = Select;
const { RangePicker } = DatePicker;
const Search = Input.Search;
function UserCar() {
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const { request } = useRequest();
    const [list, setList] = useState([]);
    const [listExport, setListExport] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [visible, setVisible] = useState(false);
    const [subscriptionVisible, setSubscriptionVisible] = useState(false);
    const [visibleView, setVisibleView] = useState(false);
    const [changeAdvisor, setChangeAdvisor] = useState(false);
    const [provideSession, setProvideSession] = useState(false);
    const [selected, setSelected] = useState();
    const [viewData, setViewData] = useState();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [filter, setFilter] = useState();
    const debouncedSearchText = useDebounce(searchText, 300);
    const searchInput = useRef(null);
    const navigate = useNavigate();
    const { confirm } = Modal;



    const onSearch = (e) => {
        setSearchText(e.target.value);
        setPagination({ current: 1 });
    };



    const showApproveConfirm = (record, type) => {
        let message = "";
        if (type == "is_approved") {
            message = "Are you sure you want to approve the driver ? ";
        } else {
            message = "Are you sure you want to reject the driver ? ";
        }
        setTimeout(() => {
            confirm({
                icon: <ExclamationCircleOutlined />,
                content: <Button>{message}</Button>,
                onOk() {
                    statusApproveChange(record, type);
                },
                onCancel() {
                    console.log("Cancel");
                },
            });
        }, 5);
    };

    const statusApproveChange = (record, type) => {
        setLoading(true);
        request({
            url: `/admin/usercar/approve-car/${record}?type=${type}`,
            method: "PUT",
            onSuccess: (data) => {
                setRefresh((prev) => !prev);
                setLoading(false);
            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
            },
        });
    };
    const columns = [
        {
            title: "Car Name",
            render: (_, { carName }) => {
                return <div>{carName ? carName : "--"}</div>;
            },
        },
        {
            title: "Car (Type-Make-Model)",
            render: (_, { carMake, carModel, carType }) => {
                return <div>{(carType ? carType.name + "-" : '') + (carMake ? carMake.name + "-" : "") + (carModel ? carModel.name : "")}</div>;
            },
        },

        {
            title: "Car Number",
            render: (_, { carNumber }) => {
                return (
                    <div>
                        {carNumber ? carNumber : '--'}
                    </div>
                );
            }
        },

        {
            title: "Fuel Type",
            render: (_, { fuelType }) => {
                return (
                    <div>
                        {fuelType ? fuelType : '--'}
                    </div>
                );
            }
        },
        {
            title: "User",
            render: (_, { user }) => {
                return (
                    <div>
                        {user ? user.name : '--'}
                    </div>
                );
            }
        },

        // {
        //     title: "STATUS",
        //     key: "is_active",
        //     filters: [
        //         {
        //             text: "Active",
        //             value: true,
        //         },
        //         {
        //             text: "InActive",
        //             value: false,
        //         },
        //     ],
        //     // onFilter: (value, record) => record.is_active === value,
        //     render: (_, { is_deleted, is_active, _id }) => {
        //         let color = is_deleted ? "red" : is_active ? "green" : "red";
        //         return (
        //             <Tag
        //                 onClick={(e) => (!is_deleted ? showConfirm(_id) : null)}
        //                 color={color}
        //                 key={is_active}
        //             >
        //                 {is_deleted ? "DELETED" : is_active ? "Active" : "Inactive"}
        //             </Tag>
        //         );

        //     },
        // },
        {
            title: "Approve Status",
            key: "isApprove",
            filters: [
                {
                    text: "Approve",
                    value: true,
                },
                {
                    text: "Pending",
                    value: false,
                },
            ],
            // onFilter: (value, record) => record.is_active === value,
            render: (_, { isApprove, _id }) => {
                let color = isApprove ? "Brown" : "grey";
                return (
                    <Tag color={color} key={isApprove}>
                        {isApprove ? "Approved" : "Pending"}
                    </Tag>
                );
                // { is_active ? "Active" : "Inactive" }
            },
        },
        {
            title: "Registartion date",
            key: "created_at",
            dataIndex: "created_at",
            render: (_, { created_at }) => {
                return new Date(created_at).toLocaleDateString();
            },
        },
        {
            title: "Action",
            render: (_, record) => {
                return (
                    <>
                        <div className="cta_wrap">
                            {/* <Button
                                onClick={(e) => {
                                    setVisibleView(true);
                                    setViewData(record);
                                }}
                            >
                                <i class="fa fa-light fa-eye"></i>
                            </Button> */}

                            {record && !record.isApprove ? (
                                <>
                                    <Button
                                        onClick={(e) =>
                                            showApproveConfirm(record._id, "is_approved")
                                        }
                                    >
                                        <i class="fa fa-light fa-check"></i>
                                    </Button>
                                    <Button
                                        className="tableBtn"
                                        onClick={() => {
                                            showApproveConfirm(record._id, "is_rejected");
                                        }}
                                    >
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </Button>
                                </>
                            ) : null}
                        </div>
                    </>
                );
            },
        },
    ];
    useEffect(() => {
        setLoading(true);
        fetchData(pagination);
    }, [refresh, debouncedSearchText, startDate, endDate]);
    useEffect(() => {
        if (!visibleView) return;
        navigate(`/taxi-admin/view-driver/${viewData._id}`);
    }, [visibleView]);
    const handleChange = (pagination, filters) => {
        setFilter(filters.is_active);
        fetchData(pagination, filters);
    };
    const fetchData = (pagination, filters) => {
        const filterActive = filters ? filters.isApprove : null;
        request({
            url: `/admin/usercar/list?isApprove=${filterActive ? filterActive.join(",") : ""
                }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
                }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
                }&end_date=${endDate ? endDate : ""}`,
            method: "GET",
            onSuccess: (data) => {
                setLoading(false);
                setList(data.data.list.docs);
                setPagination((prev) => ({
                    current: pagination.current,
                    total: data.data.list.totalDocs,
                }));
            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
            },
        });
    };
    const handleChangeDate = (e) => {
        setStartDate();
        setEndDate();
        if (e && e.length > 0) {
            setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
            setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
        }
    };

    return (
        <Main>
            <div className="tabled">
                <Row>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="User Car Manager"
                            extra={
                                <>
                                    <Search
                                        size="large"
                                        onChange={onSearch}
                                        value={searchText}
                                        onPressEnter={onSearch}
                                    />
                                </>
                            }

                        >
                            <div className="table-responsive">
                                <Table
                                    loading={loading}
                                    columns={columns}
                                    dataSource={list}
                                    pagination={pagination}
                                    onChange={handleChange}
                                    className="ant-border-space"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>


        </Main>
    );
}








export default UserCar;
